import {Button, ConfigProvider, DatePicker, Input, Select} from "antd";
import React, {useEffect, useState} from "react";
import "../CaseListingStyles.css";
import {useDropdowns} from "../../../hooks/useDropdowns";
import {Controller, useForm} from "react-hook-form";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../store/features/loadingSlice";
import {getDataForWorkforceListing} from "../../../Services/workforce";
import {useDispatch} from "react-redux";
import dayjs from "dayjs";
import {TablePageSizeOptions, WorkforceTablePageSize} from "../../../constant";

const CaseListingFilters = ({
                                caseListingData,
                                setCaseListingData, tableParams,
                                setTableParams,
                                setTableFilters,
                            }) => {
    const dispatch = useDispatch();
    const {
        state,
        getRegionsDropDown,
        getCaseStatusDropdown,
        getAlarmTypesDropDown,
        getAllCaseTypeDropdown
    } = useDropdowns();
    const [searchText, setSearchText] = useState("");
    const {control, handleSubmit} = useForm();
    const {RangePicker} = DatePicker;

    const labelRender = (props) => {
        const {label, value} = props;
        if (label === undefined) {
            return value;
        } else {
            return label;
        }
        // return <span>No option match</span>;
    };

    useEffect(() => {
        const fetchingDropdownMenuData = async () => {
            await Promise.all([
                getRegionsDropDown(),
                getCaseStatusDropdown(),
                getAlarmTypesDropDown(),
                getAllCaseTypeDropdown()
            ]);
        };
        fetchingDropdownMenuData();
    }, []);

    const retrieveFilteredCaseListingData = (data) => {
        dispatch(SET_IS_API_CALLED("Retrieving Case Listing Data"));
        setTableFilters({
            region: data?.region,
            technicianGroupId: data?.technicianGroupId,
            caseTypeId: data?.caseTypeId,
            alarmTypeId: data?.alarmTypeId,
            caseStatusId: data?.caseStatusId,
            dateFrom: data?.date ? dayjs(data?.date[0].$d).add(dayjs().utcOffset(), "minute").format('YYYY-MM-DDTHH:mm:ss') : null,
            dateTo: data?.date ? dayjs(data?.date[1].$d).add(dayjs().utcOffset(), "minute").format('YYYY-MM-DDTHH:mm:ss') : null,
        })

        getDataForWorkforceListing({
            region: data?.region,
            technicianGroupId: data?.technicianGroupId,
            caseTypeId: data?.caseTypeId,
            alarmTypeId: data?.alarmTypeId,
            caseStatusId: data?.caseStatusId,
            dateFrom: data?.date ? dayjs(data?.date[0].$d).add(dayjs().utcOffset(), "minute").format('YYYY-MM-DDTHH:mm:ss') : null,
            dateTo: data?.date ? dayjs(data?.date[1].$d).add(dayjs().utcOffset(), "minute").format('YYYY-MM-DDTHH:mm:ss') : null,
        })
            .then(res => {
                setCaseListingData(res?.data?.items);
                setTableParams({
                    pagination: {
                        current: res?.data?.pageIndex,
                        pageSize: data?.pageSize ?? WorkforceTablePageSize,
                        total: res?.data?.totalItems,
                        showSizeChanger: true,
                        pageSizeOptions: TablePageSizeOptions
                    }
                });
            })
            .finally(() => {
                dispatch(SET_IS_API_CALLED_FINISHED());
            })
    }

    const selectCaseBasedOnKeyword = () => {
        const keyword = String(searchText).toLowerCase();
        let filteredItems = caseListingData?.filter((obj) => {
            return Object.values(obj).some((objValue) => {
                return String(objValue)?.toLowerCase()?.includes(keyword);
            });
        });
        setCaseListingData(filteredItems);
    }


    return (
        <>
            <form>
                <div className="flex justify-between flex-wrap py-8">
                    <div className="basis-4/12 grid grid-cols-4 gap-3">
                        <div>
                            <Controller
                                name="region"
                                control={control}
                                render={({field}) => (
                                    <>
                                        <Select
                                            labelRender={labelRender}
                                            allowClear
                                            style={{
                                                width: '100%',
                                                overflowY: "hidden",
                                                overflowX: "ellipsis",
                                                maxWidth: "100%",
                                                height: "36px",
                                            }}
                                            placeholder="Region"
                                            onChange={field.onChange}
                                            value={field.value}
                                            options={state.regionsDropDown?.map((val) => {
                                                return {
                                                    value: val?.name,
                                                    label: val?.name,
                                                };
                                            })}
                                            className={"max-w-full max-h-full w-100"}
                                        />
                                    </>
                                )}
                            />
                        </div>
                        <div>
                            <Controller
                                name="caseTypeId"
                                control={control}
                                render={({field}) => (
                                    <>
                                        <Select
                                            labelRender={labelRender}
                                            allowClear
                                            style={{
                                                width: '100%',
                                                overflowY: "hidden",
                                                overflowX: "ellipsis",
                                                maxWidth: "100%",
                                                height: "36px",
                                            }}
                                            placeholder="Case Type"
                                            onChange={field.onChange}
                                            value={field.value}
                                            options={state.caseTypes?.map((val) => {
                                                return {
                                                    value: val?.id,
                                                    label: val?.name,
                                                };
                                            })}
                                            className={"max-w-full max-h-full w-100 py"}
                                        />
                                    </>
                                )}
                            />
                        </div>
                        <div>
                            <Controller
                                name="alarmTypeId"
                                control={control}
                                render={({field}) => (
                                    <>
                                        <Select
                                            labelRender={labelRender}
                                            allowClear
                                            style={{
                                                width: '100%',
                                                overflowY: "hidden",
                                                overflowX: "ellipsis",
                                                maxWidth: "100%",
                                                height: "36px",
                                            }}
                                            placeholder="Alarm Type"
                                            onChange={field.onChange}
                                            value={field.value}
                                            options={state.alarmTypesDropDown?.map((val) => {
                                                return {
                                                    value: val?.id,
                                                    label: val?.name,
                                                };
                                            })}
                                            className={"max-w-full max-h-full w-100 py"}
                                        />
                                    </>
                                )}
                            />
                        </div>
                        <div>
                            <Controller
                                name="caseStatusId"
                                control={control}
                                render={({field}) => (
                                    <>
                                        <Select
                                            labelRender={labelRender}
                                            allowClear
                                            style={{
                                                width: '100%',
                                                overflowY: "hidden",
                                                overflowX: "ellipsis",
                                                maxWidth: "100%",
                                                height: "36px",
                                            }}
                                            label={"name"}
                                            placeholder="Case Status"
                                            onChange={field.onChange}
                                            value={field.value}
                                            options={state?.caseStatusDropdown?.map((val) => {
                                                return {
                                                    value: val?.id,
                                                    label: val?.name,
                                                };
                                            })}
                                            className={"max-w-full max-h-full w-100 py"}
                                        />
                                    </>
                                )}
                            />
                        </div>
                    </div>

                    <div className="flex items-center gap-4">
                        <div>
                            <Input placeholder="Search" onChange={(evt) => {
                                setSearchText(evt.target.value);
                            }}/>
                        </div>
                        <div>
                            <Button type={"button"} onClick={() => {
                                selectCaseBasedOnKeyword();
                            }}>
                                <img src="/assets/search-alt-1-svgrepo-com.svg" alt="Search"/>
                            </Button>
                        </div>
                    </div>
                    <div className="flex basis-3/12 items-center gap-3">
                        <div className="basis-2/12">
                            <p>Date</p>
                        </div>
                        <div className="w-full">
                            <ConfigProvider
                                theme={{
                                    components: {
                                        DatePicker: {
                                            /* here is your component tokens */
                                            inputFontSize: 10
                                        },
                                    },
                                    token: {
                                        fontSize: 10
                                    }
                                }}
                            >
                                <Controller
                                    name="date"
                                    control={control}
                                    render={({field}) => (
                                        <RangePicker
                                            placeholder={["", ""]}
                                            className="w-full text-xs"
                                            value={field.value}
                                            onChange={field.onChange}
                                            style={{maxHeight: "100%"}}
                                            suffixIcon={
                                                <div className="w-3 h-3">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 22 25"
                                                        fill="none"
                                                    >
                                                        <path
                                                            id="Icon awesome-calendar-alt"
                                                            d="M-0.00976562 22.558C-0.00976562 23.1587 0.228868 23.7348 0.653638 24.1596C1.07841 24.5844 1.65452 24.823 2.25523 24.823H18.8612C19.462 24.823 20.0381 24.5844 20.4628 24.1596C20.8876 23.7348 21.1262 23.1587 21.1262 22.558V9.72499H-0.00976562V22.558ZM15.0902 13.311C15.0908 13.161 15.1506 13.0174 15.2566 12.9114C15.3626 12.8053 15.5063 12.7455 15.6562 12.745H17.5402C17.6902 12.7455 17.8338 12.8053 17.9399 12.9114C18.0459 13.0174 18.1057 13.161 18.1062 13.311V15.198C18.1057 15.3479 18.0459 15.4916 17.9399 15.5976C17.8338 15.7037 17.6902 15.7635 17.5402 15.764H15.6532C15.5033 15.7635 15.3596 15.7037 15.2536 15.5976C15.1476 15.4916 15.0878 15.3479 15.0872 15.198L15.0902 13.311ZM15.0902 19.35C15.0908 19.2 15.1506 19.0564 15.2566 18.9504C15.3626 18.8443 15.5063 18.7845 15.6562 18.784H17.5402C17.6902 18.7845 17.8338 18.8443 17.9399 18.9504C18.0459 19.0564 18.1057 19.2 18.1062 19.35V21.237C18.1057 21.3869 18.0459 21.5306 17.9399 21.6366C17.8338 21.7427 17.6902 21.8025 17.5402 21.803H15.6532C15.5033 21.8025 15.3596 21.7427 15.2536 21.6366C15.1476 21.5306 15.0878 21.3869 15.0872 21.237L15.0902 19.35ZM9.04823 13.311C9.04876 13.161 9.10856 13.0174 9.21459 12.9114C9.32063 12.8053 9.46428 12.7455 9.61423 12.745H11.5012C11.6512 12.7455 11.7948 12.8053 11.9009 12.9114C12.0069 13.0174 12.0667 13.161 12.0672 13.311V15.198C12.0667 15.3479 12.0069 15.4916 11.9009 15.5976C11.7948 15.7037 11.6512 15.7635 11.5012 15.764H9.61423C9.46428 15.7635 9.32063 15.7037 9.21459 15.5976C9.10856 15.4916 9.04876 15.3479 9.04823 15.198V13.311ZM9.04823 19.35C9.04876 19.2 9.10856 19.0564 9.21459 18.9504C9.32063 18.8443 9.46428 18.7845 9.61423 18.784H11.5012C11.6512 18.7845 11.7948 18.8443 11.9009 18.9504C12.0069 19.0564 12.0667 19.2 12.0672 19.35V21.237C12.0667 21.3869 12.0069 21.5306 11.9009 21.6366C11.7948 21.7427 11.6512 21.8025 11.5012 21.803H9.61423C9.46428 21.8025 9.32063 21.7427 9.21459 21.6366C9.10856 21.5306 9.04876 21.3869 9.04823 21.237V19.35ZM3.00923 13.311C3.00976 13.161 3.06956 13.0174 3.17559 12.9114C3.28163 12.8053 3.42528 12.7455 3.57523 12.745H5.46323C5.61318 12.7455 5.75684 12.8053 5.86287 12.9114C5.96891 13.0174 6.02871 13.161 6.02923 13.311V15.198C6.02871 15.3479 5.96891 15.4916 5.86287 15.5976C5.75684 15.7037 5.61318 15.7635 5.46323 15.764H3.57623C3.42628 15.7635 3.28263 15.7037 3.17659 15.5976C3.07056 15.4916 3.01076 15.3479 3.01023 15.198L3.00923 13.311ZM3.00923 19.35C3.00976 19.2 3.06956 19.0564 3.17559 18.9504C3.28163 18.8443 3.42528 18.7845 3.57523 18.784H5.46323C5.61318 18.7845 5.75684 18.8443 5.86287 18.9504C5.96891 19.0564 6.02871 19.2 6.02923 19.35V21.237C6.02871 21.3869 5.96891 21.5306 5.86287 21.6366C5.75684 21.7427 5.61318 21.8025 5.46323 21.803H3.57623C3.42628 21.8025 3.28263 21.7427 3.17659 21.6366C3.07056 21.5306 3.01076 21.3869 3.01023 21.237L3.00923 19.35ZM18.8612 3.68599H16.5972V1.42199C16.5967 1.22192 16.517 1.03019 16.3755 0.88871C16.234 0.747234 16.0423 0.66752 15.8422 0.666992H14.3322C14.1322 0.66752 13.9404 0.747234 13.799 0.88871C13.6575 1.03019 13.5778 1.22192 13.5772 1.42199V3.68599H7.53823V1.42199C7.53771 1.22209 7.45813 1.03051 7.31687 0.889061C7.17561 0.747614 6.98414 0.667784 6.78423 0.666992L5.27423 0.666992C5.07416 0.66752 4.88243 0.747234 4.74095 0.88871C4.59948 1.03019 4.51976 1.22192 4.51923 1.42199V3.68599H2.25523C1.65452 3.68599 1.07841 3.92463 0.653638 4.3494C0.228868 4.77417 -0.00976562 5.35028 -0.00976562 5.95099L-0.00976562 8.21499H21.1262V5.95099C21.1262 5.35028 20.8876 4.77417 20.4628 4.3494C20.0381 3.92463 19.462 3.68599 18.8612 3.68599Z"
                                                            fill="#9497A9"
                                                        />
                                                    </svg>
                                                </div>}
                                        />)}/>
                            </ConfigProvider>
                        </div>
                    </div>
                    <div className="basis-1/12">
                        <Button className="bg-medium-blue-100 text-white w-full"
                                onClick={handleSubmit(retrieveFilteredCaseListingData)}>
                            Generate
                        </Button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default CaseListingFilters;
